export default __webpack_public_path__ + "img/titem_4.b5b178d8.png";